import getAccountProperties from './getAccountProperties'
import { getCurrentProfile } from './getCurrentProfile'

/*
  Three states needed:
  null -> user doesn't give a preferences, show modal
  true -> mature content enabled
  false -> mature content disabled
 */

export const hasMatureContentEnabled = () => {
  const { matureContentEnabled } = getCurrentProfile() || {}
  const { matureContentEnabled: accountLevelEnabled } = getAccountProperties()

  return (
    matureContentEnabled === true ||
    (matureContentEnabled === undefined && accountLevelEnabled === true)
  )
}

export const hasMatureContentDisabled = () => {
  const { matureContentEnabled } = getCurrentProfile() || {}
  const { matureContentEnabled: accountLevelEnabled } = getAccountProperties()

  return (
    matureContentEnabled === false ||
    (matureContentEnabled === undefined && accountLevelEnabled === false)
  )
}

export const hasToChooseMaturePreferences = () => {
  const { matureContentEnabled } = getCurrentProfile() || {}
  const { matureContentEnabled: accountLevelEnabled } = getAccountProperties()

  return (
    matureContentEnabled === null ||
    (matureContentEnabled === undefined && accountLevelEnabled === null)
  )
}
